// SPDX-License-Identifier: AGPL-3.0-or-later

export class ScreenRecordingPermissionDeniedError extends Error {
	displayName = 'ScreenRecordingPermissionDeniedError';

	constructor(message = 'Screen recording permission denied') {
		super(message);
		this.name = 'ScreenRecordingPermissionDeniedError';
	}
}
